import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c81640c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"16px","text-align":"right"} }

import { ref, onMounted, computed, watch } from "vue";
import { message } from "ant-design-vue";
import XTable from "@/components/XATable.vue";
import {
  channelAdmDateList,
  channelList,
  channelAdmDateCreate,
  channelAccountList,
  channelDomainList,
  channelSave,
} from "@/api/api";
import XDialog from "@/components/XDialog.vue";
import type { FormInstance } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelIndex',
  props: {
  accountId: {
    type: String,
    default: "",
  },
  activeKey: {
    type: String,
    default: "1",
  },
  isRefresh: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const accountList = ref<any[]>([]);
const domainList = ref<any[]>([]);
const selectedAccount = ref();
const selectedDomain = ref();
const searchId = ref("");
const searchAccount = ref();
const tableData = ref([]);
const loading = ref(false);
const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const createIsSuffix = ref(1);

const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 100 },
  { title: "账号", dataIndex: "accountName", key: "accountName" },
  { title: "通道地址", dataIndex: "url", key: "url", slot: true },
  {
    title: "创建时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
  { title: "广告数量", dataIndex: "count", key: "count", width: 100 },
  { title: "操作", dataIndex: "action", key: "action", width: 120 },
];

watch(
  () => props.accountId,
  (newVal) => {
    searchAccount.value = newVal;
    fetchTableData();
  }
);
watch(
  () => props.isRefresh,
  (cur, old) => {
    fetchTableData();
  }
);
watch(
  () => props.activeKey,
  (cur, old) => {
    if (cur === "1") {
      getAccountList();
      getDomainList();
    }
  }
);
const fetchTableData = async () => {
  loading.value = true;
  try {
    const params: any = {
      pageNo: pageNo.value,
      pageSize: pageSize.value,
    };
    if (searchId.value) params.id = searchId.value;
    if (searchAccount.value) params.accountId = searchAccount.value;
    const res = await channelList(params);
    tableData.value = res.data.records || [];
    total.value = res.data.total || 0;
  } catch (e) {
    message.error("获取数据失败");
  } finally {
    loading.value = false;
  }
};

const createChannel = async () => {
  if (!selectedAccount.value || !selectedDomain.value) {
    message.warning("请选择账号和域名");
    return;
  }
  const selectedDomainObj = domainList.value.find(
    (item) => item.id === selectedDomain.value
  );
  const url = selectedDomainObj ? selectedDomainObj.name : "";
  const params = {
    accountId: selectedAccount.value,
    url,
    isSuffix: createIsSuffix.value,
    // 其他字段如有
  };
  const res = await channelSave(params);
  if (res.code === "200") {
    message.success("创建通道成功");
    fetchTableData();
  } else {
    message.error(res.msg || "创建通道失败");
  }
};

const adDialogVisible = ref(false);
const adTableData = ref([]);
const adLoading = ref(false);
const adPageNo = ref(1);
const adPageSize = ref(10);
const adTotal = ref(0);
const currentChannel = ref<any>(null);
const addAdDialogVisible = ref(false);
const adForm = ref({
  advertisingId: "",
  advertisingKey: "",
  title: "",
  //   isSuffix: 1,
  channelId: "",
});
const adFormRef = ref<FormInstance>();
const addAdLoading = ref(false);

const adColumns = [
  {
    title: "广告ID",
    dataIndex: "advertisingId",
    key: "advertisingId",
    width: 180,
  },
  { title: "广告KEY", dataIndex: "advertisingKey", key: "advertisingKey" },
  { title: "标题", dataIndex: "title", key: "title" },
  {
    title: "创建时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
  // 可根据实际接口补充更多字段
];

const adFormRules = {
  advertisingId: [{ required: true, message: "请输入广告ID" }],
  advertisingKey: [{ required: true, message: "请输入广告KEY" }],
  title: [{ required: true, message: "请输入广告标题" }],
};

const openAdDialog = (record: any) => {
  currentChannel.value = record;
  adDialogVisible.value = true;
  adPageNo.value = 1;
  fetchAdTableData();
};
const closeAdDialog = () => {
  adDialogVisible.value = false;
  fetchTableData();
};
const fetchAdTableData = async () => {
  if (!currentChannel.value) return;
  adLoading.value = true;
  try {
    const params: any = {
      id: currentChannel.value.id,
      pageNo: adPageNo.value,
      pageSize: adPageSize.value,
    };
    const res = await channelAdmDateList(params);
    adTableData.value = res.data.records || [];
    adTotal.value = res.data.total || 0;
  } catch (e) {
    message.error("获取广告列表失败");
  } finally {
    adLoading.value = false;
  }
};
const onAdPageChange = (page: number) => {
  adPageNo.value = page;
  fetchAdTableData();
};
const handleAddAd = async () => {
  if (!adFormRef.value) return;
  try {
    await adFormRef.value.validate();
    addAdLoading.value = true;
    const params = {
      ...adForm.value,
      channelId: currentChannel.value?.id,
    };
    const res = await channelAdmDateCreate(params);
    if (res.code === "200") {
      message.success("添加成功");
      closeAddAdDialog();
      fetchAdTableData();
    } else {
      message.error(res.msg);
    }
  } catch (e) {
    // 校验失败自动提示，无需额外处理
  } finally {
    addAdLoading.value = false;
  }
};
const openAddAdDialog = () => {
  addAdDialogVisible.value = true;
  adForm.value = {
    advertisingId: "",
    advertisingKey: "",
    title: "",
    isSuffix: 1,
    channelId: currentChannel.value?.id,
  };
  adFormRef.value?.resetFields();
};
const closeAddAdDialog = () => {
  addAdDialogVisible.value = false;
};

const onPageChange = (page: number) => {
  pageNo.value = page;
  fetchTableData();
};

const adDialogTitle = computed(() => {
  return currentChannel.value
    ? `广告列表（通道ID: ${currentChannel.value.id}）`
    : "广告列表";
});

const resetSearch = () => {
  searchId.value = "";
  searchAccount.value = undefined;
  fetchTableData();
};

onMounted(() => {
  getAccountList();
  getDomainList();
  fetchTableData();
});
const getAccountList = () => {
  channelAccountList({ pageNo: 1, pageSize: 1000 }).then((res) => {
    accountList.value = (res.data.records || []).map((item: any) => ({
      id: item.id,
      name: item.accountName,
    }));
  });
};
const getDomainList = () => {
  channelDomainList({ pageNo: 1, pageSize: 1000 }).then((res) => {
    domainList.value = (res.data.records || []).map((item: any) => ({
      id: item.id,
      name: item.hostName,
    }));
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { style: {"margin-bottom":"24px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "选择账号：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: selectedAccount.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedAccount).value = $event)),
                  placeholder: "-- 选择账号 --",
                  style: {"width":"180px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "选择域名：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: selectedDomain.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedDomain).value = $event)),
                  placeholder: "-- 选择域名 --",
                  style: {"width":"280px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domainList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "通道后缀：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: createIsSuffix.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((createIsSuffix).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("带")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("不带")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: createChannel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建通道")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { title: "通道广告管理" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          style: {"margin-bottom":"16px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "按ID搜索" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: searchId.value,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchId).value = $event)),
                  placeholder: "输入通道ID",
                  style: {"width":"120px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "选择账号：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: searchAccount.value,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchAccount).value = $event)),
                  placeholder: "-- 选择账号 --"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: fetchTableData
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"8px"},
                  onClick: resetSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(XTable, {
          columns: columns,
          "data-source": tableData.value,
          loading: loading.value,
          rowKey: "id",
          bordered: "",
          pagination: false
        }, {
          url: _withCtx(({ record }) => [
            _createVNode(_component_a_typography_text, {
              copyable: {
              text:
                record.isSuffix === 0
                  ? record.url
                  : record.url + `?channel=${record.id}`,
            }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.isSuffix === 0
                ? record.url
                : record.url + `?channel=${record.id}`), 1)
              ]),
              _: 2
            }, 1032, ["copyable"])
          ]),
          action: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "info",
              onClick: ($event: any) => (openAdDialog(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看广告")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["data-source", "loading"]),
        _createVNode(_component_a_pagination, {
          current: pageNo.value,
          "page-size": pageSize.value,
          total: total.value,
          onChange: onPageChange,
          style: {"margin-top":"16px","text-align":"right"}
        }, null, 8, ["current", "page-size", "total"])
      ]),
      _: 1
    }),
    _createVNode(XDialog, {
      visible: adDialogVisible.value,
      title: adDialogTitle.value,
      xWidth: "1000px",
      onCancel: closeAdDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: openAddAdDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加")
            ]),
            _: 1
          })
        ]),
        _createVNode(XTable, {
          columns: adColumns,
          "data-source": adTableData.value,
          loading: adLoading.value,
          rowKey: "id",
          bordered: "",
          pagination: false
        }, null, 8, ["data-source", "loading"]),
        _createVNode(_component_a_pagination, {
          current: adPageNo.value,
          "page-size": adPageSize.value,
          total: adTotal.value,
          onChange: onAdPageChange,
          style: {"margin-top":"16px","text-align":"right"}
        }, null, 8, ["current", "page-size", "total"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(XDialog, {
      visible: addAdDialogVisible.value,
      title: "添加广告",
      xWidth: "400px",
      onCancel: closeAddAdDialog,
      onConfirm: handleAddAd,
      confirmLoading: addAdLoading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          model: adForm.value,
          rules: adFormRules,
          ref_key: "adFormRef",
          ref: adFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "广告标题",
              name: "title",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: adForm.value.title,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((adForm.value.title) = $event)),
                  placeholder: "请输入广告标题"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "广告ID",
              name: "advertisingId",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: adForm.value.advertisingId,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((adForm.value.advertisingId) = $event)),
                  placeholder: "请输入广告ID"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "广告KEY",
              name: "advertisingKey",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: adForm.value.advertisingKey,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((adForm.value.advertisingKey) = $event)),
                  placeholder: "请输入广告KEY"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ]))
}
}

})